module.exports = __webpack_public_path__ + "static/media/icon_mj_xunhuan.1a6d9358.svg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/icon_mj_xunhuan.svg
// module id = 597
// module chunks = 0